'use client';

import { BrowserPersistence } from '@/util';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

const storage = new BrowserPersistence();

export function useMailchimpTracking() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const getSearchParam = (param: string) => searchParams?.get(param) || '';
    const mc_cid = getSearchParam('mc_cid');
    const mc_eid = getSearchParam('mc_eid');

    if (mc_cid || mc_eid) {
      const existingData = storage.getItem('mc_cid') || storage.getItem('mc_eid') || storage.getItem('mc_lp');

      if (!existingData) {
        storage.setItem('mc_cid', mc_cid);
        storage.setItem('mc_eid', mc_eid);
        storage.setItem('mc_lp', window.location.pathname + window.location.search);
      }
    }
  }, [searchParams]);
}
